import { Card, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';
import { GeneralTable } from 'src/components/general';
import { ACCOUNT_SELECTION_TABLE_HEAD } from 'src/constants/tableHeads';
import useTable from 'src/hooks/useTable';
import AccountSelectionTableRow from './AccountSelectionTableRow';

// ----------------------------------------------------------------------

export default function AccountSelectionTableModal({ selectContentHandler, isLoading, tableData, setPage }) {
  const useTableOptions = useTable();
  const { page } = useTableOptions;

  useEffect(() => {
    setPage(page);
  }, [page]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card sx={{ p: 3, overflow: 'visible' }}>
          {/* <ContentSelectionTableToolbar setFilterItems={setFilterItems} onChangePage={onChangePage} /> */}
          <Divider sx={{ my: 2 }} />
          <GeneralTable
            tableContainerSX={{
              position: 'relative',
              maxHeight: { xs: 'calc(100dvh - 250px)', lg: 'calc(100dvh - 180px)' },
            }}
            rowID="SocialManagerAccountID"
            tableData={tableData}
            headLabel={ACCOUNT_SELECTION_TABLE_HEAD}
            CustomTableRow={AccountSelectionTableRow}
            useTableOptions={useTableOptions}
            hasDeleteOption={false}
            selectContentHandler={selectContentHandler}
            isLoading={isLoading}
          />
        </Card>
      </Grid>
    </Grid>
  );
}
